"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M13.89 3.519c-.308-.9-1.1-1.351-1.89-1.35-.792-.001-1.583.45-1.892 1.35A2 2 0 0 1 7.34 4.666a2 2 0 0 0-.891-.212C5.08 4.456 3.974 5.93 4.665 7.34a2 2 0 0 1-1.147 2.77c-1.802.617-1.802 3.164 0 3.781a2 2 0 0 1 1.147 2.77c-.686 1.401.4 2.864 1.756 2.885h.043a2 2 0 0 0 .876-.211 2 2 0 0 1 2.769 1.147c.307.899 1.096 1.35 1.886 1.35.793.003 1.587-.448 1.896-1.35a2 2 0 0 1 2.769-1.147c.299.146.6.212.89.211 1.37 0 2.475-1.474 1.784-2.885a2 2 0 0 1 1.148-2.77c1.8-.617 1.8-3.164 0-3.781a2 2 0 0 1-1.148-2.77c.691-1.411-.415-2.884-1.784-2.886-.29 0-.592.066-.89.212a2 2 0 0 1-2.77-1.146M12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
  })]
}), 'SettingsFilled');
